import React, {Component, useEffect, useState} from 'react';
import './index.css';
import {render} from "react-dom";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import CustomLayout from "./pages/CustomLayout";
import Keycloak, {KeycloakConfig, KeycloakInitOptions, KeycloakInstance, KeycloakProfile} from "keycloak-js";
import {message, Spin} from "antd";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import {config} from "./Constants";
import NoPage from "./pages/NoPage";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import Dashboard from "./pages/Dashboard";
import KeycloakErrorPage from "./pages/error/KeycloakErrorPage";
import {createRoot} from "react-dom/client";
import {KeycloakControllerApi} from "./api";
import MockKeycloakProvider from "./config/MockKeycloakProvider";
import {DirtyProvider} from "./utils/hook/DirtyProvider";
import {SystemProvider} from "./utils/hook/SystemProvider";


interface AppProps {
}

interface AppState {
    name: string;
}


const keycloakConfig: KeycloakConfig = {
    url: `${config.url.KEYCLOAK_BASE_URL}`,
    realm: 'glow-realm',
    clientId: 'glow-application',
};

const keycloak: KeycloakInstance = new Keycloak(keycloakConfig);
const initOptions = {pkceMethod: 'S256'};

const handleOnEvent = async (event: string, error: any) => {
    if (event === 'onAuthSuccess') {
        if (keycloak.authenticated) {
            console.log("User authenticated");
        }
    }
};


const loadingComponent = (
    <KeycloakErrorPage/>
);

function App() {

    const [keycloakEnabled, setKeycloakEnabled] = useState(true);

    const keycloakApi = new KeycloakControllerApi();

    useEffect(() => {
        keycloakApi.isKeycloakEnabled()
            .then((axiosResponse) => {
                setKeycloakEnabled(axiosResponse.data);
                // message.info("Keycloak-Einstellungen wurden übernommen!");
            })
            .catch(error => message.error("Keycloak-Status nicht gefunden! Keycloak wird aktiviert"))
    }, []);

    if (!keycloakEnabled) {
        return (
            <MockKeycloakProvider>
                <BrowserRoutes/>
            </MockKeycloakProvider>
        );
    }

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={initOptions}
            LoadingComponent={loadingComponent}
            onEvent={handleOnEvent}
        >
            <BrowserRoutes/>
        </ReactKeycloakProvider>
    );
}

function BrowserRoutes() {
    return (
        <DirtyProvider>
            <SystemProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<CustomLayout/>}>
                            <Route index element={<Dashboard/>}/>
                            <Route path="blogs" element={<Blogs/>}/>
                            <Route path="contact" element={<Contact/>}/>
                            <Route path="*" element={<NoPage/>}/>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </SystemProvider>
        </DirtyProvider>
    );
}


const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App/>);
